import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid, styled, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Tooltip } from '@material-ui/core';

export function StyledCustomTable({ refresh, setRefresh, columns, dataEndpoint, pageSize, title, actions, onRowClick, tableHeight }) {
    const [data, setData] = useState<any[]>([]);
    const [query, setQuery] = useState<any>({
        page: 1
    });
    const [numberOfItems, setNumberOfItems] = useState<number>(-1);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [hasFullData, setHasFullData] = useState<boolean>(false);
    const [fullData, setFullData] = useState<any[]>([]);
    const [numberPerPage, setNumberPerPage] = useState<number>(0);

    useEffect(() => {
        if(refresh && dataEndpoint) {
            getData();
        }
    }, [refresh])// eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => getData(), [query])// eslint-disable-line react-hooks/exhaustive-deps

    const getData = () => {
        setLoading(true)
        dataEndpoint(query)
            .then(x =>{
                setLoading(false)
                setRefresh(false)
                if(x.data.length > x.numberPerPage){
                    setData(x.data.slice(0, x.numberPerPage))
                    setFullData(x.data)
                    setHasFullData(true)
                    setNumberPerPage(x.numberPerPage)
                } else {
                    setData(x.data)
                }
                setNumberOfItems(x.totalCount)
            }).catch(x => {
                setQuery({page:1})
                setRefresh(true)
                alert("Failed to get page.")
            })
    }

    const changePage = (e, page) => {
        if(hasFullData){
            setData(fullData.slice(page*numberPerPage, (page+1)*numberPerPage));
            setPageNumber(page)
        } else {
            setPageNumber(page);
            setQuery({
                page: page+1
            });
        }
    }

    const StyledTableRow = styled(TableRow) ({
        '&:nth-of-type(odd)': {
          backgroundColor: "white",
        },
        '&:nth-of-type(even)': {
          backgroundColor: "#F9F9F9",
        },
      });

    return ( loading ?
        <CircularProgress className='center-spinner' /> :
        <>
        <h3 style={{float:"left"}}>{title}</h3>
        {actions?.some(x => x.isFreeAction) &&
            actions.filter(x => x.isFreeAction).map(x => (
                <Tooltip title={x.tooltip} placement="bottom" style={{ float:"right", marginTop:"30px", marginRight:"30px", cursor:"pointer" }}>
                    <span onClick={x.onClick}>
                        {x.icon()}
                    </span>
                </Tooltip>
            ))
        }
        <Grid style={{ overflowY: "auto", height: tableHeight, width: "100%", scrollbarWidth: "thin" }}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {columns.map(x => (
                            <>
                                {!x.hidden &&
                                    <TableCell key={x} style={{textAlign: "center"}}>{x.title}</TableCell>
                                }
                            </>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading &&
                        <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                    }
                    {data?.map((row) => (
                        <StyledTableRow key={row.name} onClick={() => onRowClick && onRowClick(row)} style={{ cursor: onRowClick ? "pointer" : "auto" }}>
                            {columns.map(x => (
                                <>
                                    {!x.hidden &&
                                        <TableCell key={x} style={{textAlign: "center"}}>{x?.render ? x.render(row) : row[x.field]}</TableCell>
                                    }
                                </>
                            ))}
                        </StyledTableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    {numberOfItems > pageSize &&
                        <TablePagination SelectProps={{disabled: loading}}
                            backIconButtonProps={
                                loading
                                ? {
                                    disabled: loading
                                }
                                : undefined
                            }
                            nextIconButtonProps={
                                loading
                                ? {
                                    disabled: loading
                                }
                                : undefined
                            }
                            count={numberOfItems} onPageChange={changePage} page={pageNumber} rowsPerPage={pageSize} rowsPerPageOptions={[]}></TablePagination>
                        }
                </TableFooter>
            </Table>
            {data.length === 0 && !loading &&
                <div style={{textAlign: "center", margin: "20px auto 0px auto", fontSize: "14px"}}>No items to show.</div>
            }
        </Grid>
    </>)

}
